import { TFunction } from 'i18next';
import { DataTableMeta, DateColumn } from '@otp/ui';
import { UserCertificateListItem } from 'src/components/organisation/manage-otps/user-details/user-certificates/types';
import { ActionsField } from './columns/actions';

export const getTableConfig = (
  userCertificates: UserCertificateListItem[],
  { t, withoutActions }: { t: TFunction; withoutActions: boolean },
) => [
  {
    name: 'name',
    label: t('common.certificate'),
  },
  {
    name: 'userCertificateCurriculum.name',
    label: t('common.curriculum'),
  },
  {
    name: 'userMcId',
    label: t('common.eid-acquired'),
  },
  {
    name: 'userCertificateCreatedAt',
    label: t('common.acquired-on'),
    options: {
      customBodyRender: (userCertificateCreatedAt: string) => {
        return <DateColumn date={userCertificateCreatedAt} />;
      },
    },
  },
  ...(withoutActions
    ? []
    : [
        {
          name: 'actions',
          label: t('common.actions'),
          options: {
            customBodyRender: (_: any, column: DataTableMeta) => {
              const certificate = userCertificates[column.rowIndex];

              return <ActionsField certificate={certificate} />;
            },
          },
        },
      ]),
];
